<div id="error-page" *ngIf="error">

    <h1>Oops!</h1>
    <img alt="horse error page" height="200" [src]="'assets/img/cavallino-a-dondolo.svg'"/>
    <h2>{{error.statusText}}: {{error.status}}</h2>
    <div class="error-message">{{error.message}}</div>


    <small *ngIf="error.actionNam === 'getIdentify'">
        Partner id problem (<span>CID: {{this.pageCID$ | async}}</span>)
    </small>
</div>
